// extracted by mini-css-extract-plugin
export var form = "_5m-0";